<section id="auth" class="relative h-screen w-full">

    <!-- Fluid Content Wrapper -->
    <main class="relative z-10 w-full h-full">
        <router-outlet></router-outlet>
    </main>
</section>